import React, { useState } from 'react'
import { postInsertarMaestroConcentracion } from '../../../services/ApiSuministros'
import ModalErrorMaestroConcentracion from './ModalErrorMaestroConcentracion'

const InsertMaestroConcentracion = ({setmodalOnInsertarMaestroConcentracion, setactualizarData}) => {
    const [loading,setloading]=useState(true)
    const [modalOnErrorMaestroConcentracion, setmodalOnErrorMaestroConcentracion]=useState(false)
    const [errorCodigo, seterrorCodigo]=useState('Ingresar un código')
    const [errorDescripcion, seterrorDescripcion]=useState('Ingresar una descripción')
    const [mensajeError, setmensajeError]=useState('')
    const handleCancelarClick=()=>{
        setmodalOnInsertarMaestroConcentracion(false)
    }

    const handleOnSubmitInsertar=(e)=>{
        e.preventDefault()
        const insertar={
            'CncCd': e.target.codigo.value,
            'CncDes': e.target.descripcion.value
        }
        if(errorCodigo === '' && errorDescripcion === ''){
            setloading(false)        
            postInsertarMaestroConcentracion(insertar).then((res)=>{
                setloading(true)
                if(res.data.success){
                    setactualizarData(insertar)                
                    setmodalOnInsertarMaestroConcentracion(false)
                }else{
                    setmensajeError(res.data.message)
                    setmodalOnErrorMaestroConcentracion(true)
                }
                
            })
        }
        
    }

    const handleChangeCodigo=(e)=>{
        if(e.target.value.trim()){
            seterrorCodigo('')
        }else{
            seterrorCodigo('Ingresar un código')
        }
    }

    const handleChangeDescripcion=(e)=>{
        if(e.target.value.trim()){
            seterrorDescripcion('')
        }else{
            seterrorDescripcion('Ingresar una descripción')
        }
    }
  return (
    <div
    className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
    id="exampleModalScrollable"
    tabIndex="-1"
    aria-labelledby="exampleModalScrollableLabel"
    aria-hidden="true"
  >
    <div className="sm:h-[calc(100%-3rem)] max-w-5xl  mx-auto relative w-auto pointer-events-none ">
      <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
        <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">        
    <h5
      className="text-xl font-medium leading-normal text-white"
      id="exampleModalScrollableLabel"
    >
     Crear Maestro Concentración
    </h5>  
          <button
            type="button"
            onClick={handleCancelarClick}
            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            X
          </button>
        </div>
        <div className="flex-auto overflow-y-auto relative" >
            <form onSubmit={handleOnSubmitInsertar}>
              <div className="flex">                
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Código 
                  </label>
                  <input
                    onChange={(e) => {
                        // Capturamos el valor actual del input
                        let inputValue = e.target.value;
  
                        // Si el valor supera los 50 caracteres, lo truncamos
                        if (inputValue.length > 4) {
                          e.target.value = inputValue.slice(0, 4);
                        }

                        handleChangeCodigo(e)
                      }}        
                    name='codigo'
                    autoComplete="off"
                    type="text"
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                    
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorCodigo}
                  </label>
                  
                </div>
                
                
              </div>
              <div className="flex my-2">
              
                <div className="w-full  px-1 ">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                    Descripción 
                  </label>
                  <input                    
                    
                    onChange={(e) => {
                        // Capturamos el valor actual del input
                        let inputValue = e.target.value;
  
                        // Si el valor supera los 50 caracteres, lo truncamos
                        if (inputValue.length > 80) {
                          e.target.value = inputValue.slice(0, 80);
                        }
                        handleChangeDescripcion(e)
                      }}                    
                    name='descripcion'             
                    autoComplete="off"
                    type="text" 
                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                    id="exampleFormControlInput1"
                    placeholder=""
                  />
                  <label  className="form-label inline-block mb-2 text-red-900 text-sm font-medium" >
                        {errorDescripcion}
                  </label>                  
                </div>
              </div> 
              
        
        <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
          <button
            type="button"
            onClick={handleCancelarClick}
            className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
          <button type="submit"
            className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
            Aceptar
          </button>
        </div>
        </form>
        </div>
        
      </div>
    </div>    
    {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            } 
    
    {modalOnErrorMaestroConcentracion? <ModalErrorMaestroConcentracion setmodalOnErrorMaestroConcentracion={setmodalOnErrorMaestroConcentracion} mensajeError={mensajeError}/>:null}
    
  </div>
  )
}

export default InsertMaestroConcentracion